import { defaultTheme } from 'react-admin'
import { deepmerge } from '@mui/utils'

const baseBackgroundColor = '#B4D4D3'
const baseColor = '#121212'
const complementaryLight = '#f4ddce'

const theme = deepmerge(defaultTheme, {
  components: {
    RaCreateButton: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
        },
      },
    },
    RaFilterForm: {
      styleOverrides: {
        root: {
          minHeight: '0 !important',
        },
      },
    },
    RaHeader: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.toolbar.main,
          color: '#fff',
        }),
      },
    },
    RaDatagrid: {
      styleOverrides: {
        root: {
          '& .RaDatagrid-headerCell': {
            fontSize: '9pt',
            // backgroundColor: complementaryLight,
            backgroundColor: '#83b7bb',
            color: '#fefefe'
          },
          '& .RaDatagrid-rowCell': {
            fontSize: '8.5pt',
            '& .MuiTypography-root': {
              fontSize: '8.5pt', // for custom fields using Typography
            },
          },
          '& .MuiTableRow-root:has(.select-item input:checked)': {
            backgroundColor: '#B4D4D3',
            '&:hover': {
              backgroundColor: '#B4D4D3',
            },
          },
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: baseBackgroundColor,
          color: baseColor
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          // Default styles for all tabs can go here
          '&.Mui-selected': {
            // backgroundColor: '#eaf0ed',
            backgroundColor: '#d9e9e4',
            // color: '#6c9781'
            color: '#2a6566',
          },
        },
      },
    },
    MuiGrid2: {
      styleOverrides: {
        container: {
          width: '100%'
        },
      },
    },
  },
  typography: {
    ...defaultTheme.typography,
    fontFamily: 'Poppins, Arial, sans-serif', // Set Poppins as the default font
    body1: { fontSize: '0.85rem' },
    h6: { fontWeight: 600, color: '#444' },
    h5: { fontWeight: 600, color: '#444' },
    h4: { fontWeight: 700, color: '#333' },
    h3: { fontWeight: 700, color: '#333' },
    h2: { fontWeight: 800, color: '#222' },
    h1: { fontWeight: 800, color: '#222' },
  },
  palette: {
    ...defaultTheme.palette,
    primary: {
      light: '#449b9e',
      main: '#296d6f',
      dark: '#205557',
    },
    secondary: {
      main: '#b0c7bb',
      light: '#c6d1ce',
      dark: '#6f8a81',
    },
    ternary: {
      main: '#F5EFE8',
      light: '#faf8f6',
      dark: '#e8ddd1',
    },
    complementary: {
      main: '#c38b6e',
      light: complementaryLight,
      dark: '#b6714d',
    },
    info: {
      main: '#333'
    },
    tabs: {
      main: '#4e8988'
    },
    toolbar: {
      main: '#2a6566',
    },
    mint: {
      // main: '#c2e0df'
      main: '#f0ece8'
    },
    cards: {
      backgroundColor: {
        main: '#e6edf1',
      },
      title: {
        main: '#325857',
      },
      contentBackgroundColor: {
        main: '#fff',
      },
    },
    gridList: {
      backgroundColor: '#f0f4f3',
      cards: {
        backgroundColor: '#ffffff',
        textColor: '#1a2e2e',
        textDate: '#6a7f7e',
        icon: '#2D8C7A',
        chipBackgroundColor: '#3a8a7a',
      }
    },
    filterPanel: {
      backgroundColor: '#e6f2f1',
      color: '#333',
    },
    ongoing: {
      main: '#e67e22',
    },
    waiting: {
      main: '#8ea3a0',
    },
    favourited: {
      by: '#c84637'
    },
    state: {
      candidate:  '#2c7da0',
      interested: '#4a8f5e',
      locked:     '#c84637',
      lastopened: '#1f4f50',
    },
    status: {
      recontacter: { bg: '#fbd8c2', fg: '#934f2c', border: '#d9a684' },
      encours:     { bg: '#d6e7f0', fg: '#1f4663', border: '#8eb6cf' },
      inscrit:     { bg: '#b8dad9', fg: '#154443', border: '#7eb9b7' },
      refuse:      { bg: '#ddd5c7', fg: '#4f4332', border: '#b6a78f' },
      rgpd:        { bg: '#fde0db', fg: '#8a2918', border: '#e89485' },
      email:       { bg: '#fbd8c2', fg: '#934f2c', border: '#d9a684' },
    },
    origin: {
      salon:      '#449295',
      site:       '#84b4b1',
      reco:       '#c38b6e',
      instagram:  '#b06ab3',
      facebook:   '#4267b2',
      google:     '#d4a13a',
      import:     '#6f8a81',
      partenaire: '#934f2c',
      evenement:  '#2c7da0',
      formulaire: '#4a8f5e',
      tel:        '#325857',
      autre:      '#b6a78f',
    },
  },
})

export default theme